export default __webpack_public_path__ + "static/media/aaave.0af724b9.svg";